/**
 * Casa del Bacalao · etiqueta "Más vendido" con datos reales.
 *
 * Fuente: /collections/all?sort_by=best-selling&view=casa-top (templates/collection.casa-top.liquid),
 * que devuelve los handles DISPONIBLES en el orden de ventas de Shopify. Se marcan los primeros TOP.
 * Nunca se inventa: si la petición falla, no se muestra nada.
 */
const TOP = 4;
const CLAVE = 'casa:mas-vendidos';
const VIGENCIA_MS = 60 * 60 * 1000;

let peticion = null;
function masVendidos() {
  if (peticion) return peticion;
  try {
    const guardado = JSON.parse(sessionStorage.getItem(CLAVE) || 'null');
    if (guardado && Date.now() - guardado.t < VIGENCIA_MS && Array.isArray(guardado.h) && guardado.h.length) {
      peticion = Promise.resolve(new Set(guardado.h));
      return peticion;
    }
  } catch {
    /* sin almacenamiento */
  }
  peticion = fetch('/collections/all?sort_by=best-selling&view=casa-top')
    .then((r) => (r.ok ? r.text() : '[]'))
    .then((t) => {
      const lista = JSON.parse(t.trim() || '[]').filter(Boolean).slice(0, TOP);
      if (!lista.length) return new Set();
      try {
        sessionStorage.setItem(CLAVE, JSON.stringify({ t: Date.now(), h: lista }));
      } catch {
        /* nada */
      }
      return new Set(lista);
    })
    .catch(() => new Set());
  return peticion;
}

async function marcar(raiz = document) {
  const pendientes = [...raiz.querySelectorAll('[data-casa-mas-vendido]:not([data-casa-revisado])')];
  if (!pendientes.length) return;
  const top = await masVendidos();
  for (const badge of pendientes) {
    badge.setAttribute('data-casa-revisado', '');
    if (!top.has(badge.getAttribute('data-casa-mas-vendido'))) continue;
    // Oculta el badge de menor prioridad que venga antes (Nuevo / Solo CDMX)
    const previo = badge.previousElementSibling;
    if (previo && previo.matches('[data-casa-badge="nuevo"], [data-casa-badge="cdmx"]')) previo.hidden = true;
    badge.hidden = false;
  }
}

if (!window.__casaMasVendido) {
  window.__casaMasVendido = true;
  marcar();
  // Tarjetas que llegan después (recomendaciones, "ver más", carrito re-dibujado)
  new MutationObserver((muts) => {
    if (muts.some((m) => m.addedNodes.length)) marcar();
  }).observe(document.documentElement, { childList: true, subtree: true });
}
